<button
	mat-button
	class="mat-stroked-button"
	[style]="customStyle"
	[class.filled]="type === 'filled'"
	[class.outlined]="type === 'outlined'"
	[class.outlined-1]="type === 'outlined-1'"
	[class.outlined-2]="type === 'outlined-2'"
	(click)="onButtonClick($event)"
	[disabled]="disabled"
	[attr.aria-keyshortcuts]="ariaKeyShortcut || null"
>
	<mat-icon *ngIf="matIcon">{{ matIcon }}</mat-icon>
	{{ title | i18next: { format: format } }}
</button>
